// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const DepartmentsService = {
    /**
     * Department APIs
     */
    Read(fn, req) {
        try {
            fm.validateUrlParam(req["departmentId"], "departmentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/departments/v2/${req["departmentId"]}?${fm.renderURLSearchParams(req, ["departmentId"])}`, { method: "GET" });
    },
    List(fn, req) {
        return fn(`/phone-exp/departments/v2?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    Create(fn, req) {
        return fn(`/phone-exp/departments/v2`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    Update(fn, req) {
        return fn(`/phone-exp/departments/v2`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    Delete(fn, req) {
        try {
            fm.validateUrlParam(req["departmentId"], "departmentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/departments/v2/${req["departmentId"]}?${fm.renderURLSearchParams(req, ["departmentId"])}`, { method: "DELETE" });
    },
    /**
     * Voicemail APIs
     */
    GetVoicemailOverride(fn, req) {
        try {
            fm.validateUrlParam(req["departmentId"], "departmentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/departments/v2/vmo/${req["departmentId"]}?${fm.renderURLSearchParams(req, ["departmentId"])}`, { method: "GET" });
    },
    UpdateVoicemailOverride(fn, req) {
        return fn(`/phone-exp/departments/v2/vmo`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    CountVoicemail(fn, req) {
        return fn(`/phone-exp/departments/v2/count-voicemail?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListVoicemailBoxes(fn, req) {
        return fn(`/phone-exp/departments/v2/voicemail-boxes?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * PhoneNumber APIs
     */
    ListPhoneNumbers(fn, req) {
        return fn(`/phone-exp/departments/v2/phone-numbers?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    AddPhoneNumbers(fn, req) {
        return fn(`/phone-exp/departments/v2/phone-numbers`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdatePhoneNumber(fn, req) {
        return fn(`/phone-exp/departments/v2/phone-number`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateAndRemovePhoneNumbers(fn, req) {
        return fn(`/phone-exp/departments/v2/update-remove-phone-numbers`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    RemovePhoneNumber(fn, req) {
        try {
            fm.validateUrlParam(req["departmentId"], "departmentId");
            fm.validateUrlParam(req["phoneNumberId"], "phoneNumberId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/departments/v2/${req["departmentId"]}/phone-number/${req["phoneNumberId"]}?${fm.renderURLSearchParams(req, ["departmentId", "phoneNumberId"])}`, { method: "DELETE" });
    },
    ListDefaultSMS(fn, req) {
        return fn(`/phone-exp/departments/v2/default-sms?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * This endpoint updates the call route for a department.
     */
    UpdateCallRoute(fn, req) {
        try {
            fm.validateUrlParam(req["departmentId"], "departmentId");
            fm.validateUrlParam(req["scheduleId"], "scheduleId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/departments/v2/${req["departmentId"]}/schedules/${req["scheduleId"]}/call-route`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    CreateSchedule(fn, req) {
        return fn(`/phone-exp/departments/v2/schedule`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListSchedules(fn, req) {
        return fn(`/phone-exp/departments/v2/schedules?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateSchedule(fn, req) {
        return fn(`/phone-exp/departments/v2/schedule`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteSchedule(fn, req) {
        return fn(`/phone-exp/departments/v2/schedule?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    GetCallForwarding(fn, req) {
        try {
            fm.validateUrlParam(req["departmentId"], "departmentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/departments/v2/${req["departmentId"]}/callforwarding?${fm.renderURLSearchParams(req, ["departmentId"])}`, { method: "GET" });
    },
    UpdateCallForwarding(fn, req) {
        try {
            fm.validateUrlParam(req["departmentId"], "departmentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/departments/v2/${req["departmentId"]}/callforwarding`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
};
